import { useQuery } from "@tanstack/vue-query";
import baseAPI from "@/api/base";
import { computed, type Ref } from "vue";

export interface SMSConversation {
  id: string;
  organizationId: string;
  contactId: string;
  phoneNumberId: string;
  contactPhoneId?: string;
  contactPhoneNumber: string;
  unreadCount: number;
  lastMessageAt?: string;
  lastMessagePreview?: string;
  lastMessageDirection?: string;
  isActive: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  phoneNumber?: {
    id: string;
    number: string;
    region?: string;
    city?: string;
  };
  contact?: {
    id: string;
    fname: string;
    lname: string;
    email?: string;
  };
}

export function useContactSMSConversations(contactId: Ref<string | null>) {
  const enabled = computed(() => !!contactId.value);

  const query = useQuery({
    queryKey: ["sms-conversations", contactId],
    queryFn: async (): Promise<SMSConversation[]> => {
      if (!contactId.value) return [];
      const response = await baseAPI.get(`/twilio/sms/conversations`, {
        params: { contactId: contactId.value },
      });
      return response.data.data || [];
    },
    enabled,
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
  });

  return {
    ...query,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
  };
}
